module.exports = "/_next/static/images/metro-badge-5fdfe3732e53b9441d01bce22763c39c.jpg";